module.exports = __webpack_public_path__ + "static/img/1.d1c5fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/1.png
// module id = dmfS
// module chunks = 1